import { useCallback } from 'react';

import { Roles } from '@rdTypes/shared';
import { useMe } from './useMe';

export const useUserPermissions = () => {
  const { currentUser } = useMe();

  const isAllowed = useCallback(
    (requiredInterface: Roles[]) => {
      const roles = currentUser ? (currentUser.roles as Roles[]) : [];

      if (roles.includes(Roles.KTAdmin)) return true;

      const filteredArray = roles.filter((value) => requiredInterface.includes(value));
      return filteredArray.length ? true : false;
    },
    [currentUser],
  );

  return { isAllowed };
};
